import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaDecoracion from './TablaDecoracion';

const Decoracion: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaDecoracion />
    </Box>
  );
};

export default Decoracion;
